import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { useMe } from "@/context/MeContext";
import { Footer, GoldDots } from "@/components/Brand";

export const Loading = () => (
  <div className="min-h-screen flex flex-col bg-alabaster" data-testid="page-loading">
    <div className="flex-1 flex items-center justify-center"><GoldDots /></div>
    <Footer />
  </div>
);

export default function Protected({ children, needProfile = true, admin = false }) {
  const { isLoaded, isSignedIn } = useAuth();
  const { me, loading } = useMe();
  const loc = useLocation();
  if (!isLoaded) return <Loading />;
  if (!isSignedIn) return <Navigate to="/sign-in" replace state={{ from: loc.pathname }} />;
  if (loading || !me) return <Loading />;
  if (needProfile && !me.profile_complete) return <Navigate to="/profile-setup" replace />;
  if (admin && me.role !== "admin") return <Navigate to="/" replace />;
  const allowed = { restricted: ["/settings", "/payment"], lapsed: ["/membership", "/payment", "/settings"] }[me.access];
  if (allowed && me.role !== "admin" && !allowed.some((p) => loc.pathname.startsWith(p))) return <Navigate to={allowed[0]} replace />;
  return children;
}
